export enum DebtorDetailsFormNamesEnum {
  FORM_GROUP_NAME = 'DebtorDetails',
  SECONDARY_FORM_GROUP_NAME = 'SecondaryDebtorDetails',
}
